/**
 * Set the timezone offset to the number of seconds to add or subtract from UTC
 * in order to display a timestamp in the user's local time.
 *
 * Requires: jquery, json.jq, userdata.
 */

$(document).ready(function()
{
  var old_ie = $('#old_ie');
  if (old_ie.exists())
  { // Old version of IE, you're not supported.
    old_ie.show();
  }
  else
  { // Javascript enabled, with a good browser. Let's go!
    $('#login_form').show();

    // Calculate the timezone offset, and send it to PHP.
    var tzOffset = Lum.UserData.getTimezone();
    //  alert("tz: "+tzOffset);
    $('#tzoffset').val(tzOffset);

    // Gather some stats for the Access Log.
    function save_userdata (info)
    {
      $('#userdata').JSON(info);
    }
    var infoOpts =
    {
      geolocation:
      {
        onSuccess: save_userdata,
        onError:   save_userdata,
      },
      fallbackCallback: save_userdata
    };
    Lum.UserData.getInfo(infoOpts);
  }

  if (navigator.cookieEnabled)
  {
    $('#no_cookies').hide();
  }

  $('#project').css('margin: 0');
});

